import { render } from "./SecretDetails.vue?vue&type=template&id=66cac3ae&ts=true"
import script from "./SecretDetails.vue?vue&type=script&lang=ts"
export * from "./SecretDetails.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__